//#region src/utils/theme.ts
const BODY = typeof window !== "undefined" ? document.body : null;
function themeFromDocument() {
	return {
		mode: getDocumentTheme(),
		brand: getDocumentBrand(),
		enhancedContrast: getDocumentEnhancedContrast()
	};
}
function getDocumentTheme() {
	return getAttribute(BODY, "data-preferred-theme", "light");
}
function getDocumentBrand() {
	return getAttribute(BODY, "data-editor-theme", "design");
}
function getDocumentEnhancedContrast() {
	return hasAttribute(BODY, "data-enhanced-contrast");
}
/**
* Sets enhanced contrast to true or false for the *whole page*
* @warning This should only be called from inside theme_actions, otherwise
* enhanced contrast will be set without adding to user storage
*/
function setEnhancedContrastMode(value) {
	setBooleanAttribute(BODY, "data-enhanced-contrast", value);
}
const THEME_DATA_ATTRIBUTES = [
	"data-editor-theme",
	"data-preferred-theme",
	"data-enhanced-contrast"
];
/** Convert a theme object to the data attribute props that should be spread onto an element. */
function dataAttributesFromTheme({ brand, mode, enhancedContrast }) {
	return {
		"data-editor-theme": brand,
		"data-preferred-theme": mode,
		"data-enhanced-contrast": enhancedContrast || void 0
	};
}
function areModesEqual(mode1, mode2) {
	return mode1 === mode2 || mode1.mode === mode2.mode && mode1.brand === mode2.brand && mode1.enhancedContrast === mode2.enhancedContrast;
}
function getAttribute(el, key, fallback) {
	return el?.getAttribute(key) ?? fallback;
}
function hasAttribute(el, key) {
	return el?.hasAttribute(key) ?? false;
}
function setBooleanAttribute(el, key, value) {
	if (!el) return;
	if (value) el.setAttribute(key, "");
	else el.removeAttribute(key);
}
//#endregion
export { THEME_DATA_ATTRIBUTES, areModesEqual, dataAttributesFromTheme, getDocumentBrand, getDocumentEnhancedContrast, getDocumentTheme, setEnhancedContrastMode, themeFromDocument };

//# sourceMappingURL=theme.js.map